import styled from 'styled-components';

const MAIN_COLOR = '#1F1F1F';

const SiteContent = styled.div`
    background-color: ${MAIN_COLOR};
    margin: 0 auto;
    min-height: 100vh;
    position: relative;
    overflow: hidden;
`;

export default SiteContent;
